/**
 * @module Carousel
 * @description
 */
import { useEffect, useState } from 'react';
import { Pagination, Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import { v4 as uuidv4 } from 'uuid';
import { fastly } from '@/js/utils/helpers';
import { trackEvent } from '@/js/helpers/tracking';

import 'swiper/css';
import 'swiper/css/pagination';
import styles from './index.module.css';

const defaultSlides = [
  {
    image: {
      url: '/pages/home/split-section-720x514.jpg',
      blurUrl: '/pages/home/split-section-720x514.jpg',
      alt: 'Woman wearing VR - 2G text'
    },
    headline: 'Heading',
    subhead: 'Subhead',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,.'
  },
  {
    image: {
      url: '/pages/home/split-section-720x514.jpg',
      blurUrl: '/pages/home/split-section-720x514.jpg',
      alt: 'Woman wearing VR - 2G text'
    },
    headline: 'Heading 2',
    subhead: 'Subhead 2',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,.'
  },
  {
    image: {
      url: '/pages/home/split-section-720x514.jpg',
      blurUrl: '/pages/home/split-section-720x514.jpg',
      alt: 'Woman wearing VR - 2G text'
    },
    headline: 'Heading 3',
    subhead: 'Subhead 3',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,.'
  }
];

/**
 * @function Component
 * @description
 */
const Component = ( { ...props } ) => {
  const {
    slides = defaultSlides,
    theme = null
  } = props;
  const [ instanceId, setInstanceId ] = useState();
  const [ initialized, setInitialized ] = useState( false );

  useEffect( () => {
    setInstanceId( uuidv4() );
  }, [] );

  const beamSlideChange = ( slide ) => {
    const data = {
      elementType: 'SECTION',
      position: `CAROUSEL - SLIDE ${ slide }`
    };

    trackEvent( { action: 'elementViewed', data } );
  };

  return (
    <section className={ `component ${ styles.component } ${ theme && `u-theme-${ theme }` }` }>
      <div className={ `l-container ${ styles.component__itemList }` }>
        <Swiper
          className={ `${ styles.component__slider }` }
          modules={ [ Pagination, Navigation, A11y ] }
          autoHeight={ false }
          spaceBetween={ 40 }
          slidesPerView={ 1 }
          onSlideChange={ ( swiper ) => beamSlideChange( swiper.activeIndex + 1 ) }
          navigation={ {
            nextEl: `.swiper-button-next--${ instanceId }`,
            prevEl: `.swiper-button-prev--${ instanceId }`
          } }
          onSwiper={ () => {
            // Images seem to be loading faster than swiper, this meant to hold them off until Swiper has loaded.
            setInitialized( true );
          } }
          pagination={ {
            el: `.swiper-pagination--${ instanceId }`,
            type: 'bullets',
            clickable: true
          } }>
          { slides.map( ( slide, index ) => (
            <SwiperSlide key={ index } className={ styles.component__slide } >
              <div key={ index }>
                <div className={ styles.component__imgContainer }>
                  { initialized &&
                    <Image
                      alt={ slide.image.alt }
                      src={ slide.image.url }
                      loader={ fastly }
                      width={ 720 }
                      height={ 325 }
                      loading="lazy"
                    />
                  }
                </div>
                <div className={ styles.component__copyWrapper }>
                  <p className={ `h2 ${ styles.component__headline }  ${ theme && styles[ `component__headline__${ theme }` ] }` }>{ slide.headline }</p>
                  <span>
                    { slide.subhead && <h5 className={ styles.component__subhead }>{ slide.subhead }</h5> }
                    <p className={ styles.component__content }>{ slide.content }</p>
                    <p className={ `${ styles.component__legal } legal` }>{ slide.legal }</p>
                  </span>
                </div>
              </div>
            </SwiperSlide>
          ) ) }
        </Swiper>

        {/* Navigation Arrows and Pagination Bullets */}
        <div className={ `${ styles.component__navigationContainer }` }>
          {/* Previous Arrow */}
          <div className={ `swiper-button-prev--${ instanceId } icon icon-chevron-left1 ${ styles.component__swiperBtnPrev } ${ theme && styles[ `component__swiperBtn__${ theme }` ] }` } />
          {/* Pagination Bullets */}
          <div className={ `hide-for-large swiper-pagination ${ theme && `swiper-pagination__${ theme }` } swiper-pagination--${ instanceId }` } />
          {/* Next Arrow */}
          <div className={ `swiper-button-next--${ instanceId } icon icon-chevron-right1 ${ styles.component__swiperBtnNext } ${ theme && styles[ `component__swiperBtn__${ theme }` ] }` } />
        </div>
      </div>
    </section>
  );
};

export default Component;
